var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CommunicationNetworkGraphOrgTeamMeetLinkInspectorContent } from '@web/components/CommunicationNetworkGraph/components/CommunicationNetworkGraphOrgTeamMeetLinkInspectorContent';
/** CARD-46 / CARD-47 — selected employee ↔ colleague meet pair metrics. */
export var CommunicationNetworkGraphEmployeeScopePersonMeetLinkInspectorContent = function (props) { return (_jsx(CommunicationNetworkGraphOrgTeamMeetLinkInspectorContent, __assign({}, props))); };
